import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { CourseGroupPageData, GroupPageResponse } from '../../sharepointPageApi/types/pageData'
import { LinkBlock } from '../linkBlockLayout'
import { LinkGridBlockLayout } from '../linkGridBlockLayout'
import { ChildCourseGroupsBlockState } from './childCourseGroupsBlockState'

export type ChildCourseGroupsBlock = Omit<LinkBlock, 'items'> & {
  courseGroupsState: ChildCourseGroupsBlockState
}

const transformCoursePageData = (courseGroups: GroupPageResponse) : CourseGroupPageData[] => {
  const result = courseGroups.GroupPages.map((groupPage) => {
    const children = courseGroups.CoursePagesByGroups.find((item) => item.GroupId == groupPage.SharepointId);
    if (children?.CoursePages.length == 1) groupPage.AbsolutePath = children.CoursePages[0].url;
    return groupPage
  })
  return result
}

export const childCourseGroupsBlockWidget = (
  block: ChildCourseGroupsBlock
): Widget<Updater<ChildCourseGroupsBlockState>> =>
  async<GroupPageResponse>(block.courseGroupsState, courseGroups => {
    const result = transformCoursePageData(courseGroups)
    return fromJSX(() => (
      <LinkGridBlockLayout
        {...block}
        withImages={false}
        items={result.map(x => ({
          title: x.HeaderTitle,
          intro: x.HeaderDescription ?? '',
          link: {
          url: x.AbsolutePath,
          title: x.HeaderTitle
          }
        }))}
      />
    ))
  })
